"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CourseAgenda = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importStar(require("styled-components"));
var RecursiveLessons_1 = require("./_components/RecursiveLessons");
var context_1 = require("./_components/context");
var StyledSection = (0, styled_components_1.default)("section")(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n  & > header {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    justify-content: space-between;\n    align-items: flex-start;\n    align-content: flex-start;\n    margin-bottom: 20px;\n\n    .lms-icon-title {\n      margin: 0;\n      flex-wrap: nowrap;\n    }\n    & > div {\n      display: inline-flex;\n      align-items: center;\n\n      p {\n        margin-right: 6px;\n      }\n    }\n  }\n\n  & > .lessons__list {\n    padding-left: 0;\n    list-style: none;\n  }\n"], ["\n  width: 100%;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n  & > header {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    justify-content: space-between;\n    align-items: flex-start;\n    align-content: flex-start;\n    margin-bottom: 20px;\n\n    .lms-icon-title {\n      margin: 0;\n      flex-wrap: nowrap;\n    }\n    & > div {\n      display: inline-flex;\n      align-items: center;\n\n      p {\n        margin-right: 6px;\n      }\n    }\n  }\n\n  & > .lessons__list {\n    padding-left: 0;\n    list-style: none;\n  }\n"])));
var CourseAgendaContent = function (_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b;
    var lessons = (0, context_1.useCourseAgendaContext)().lessons;
    return ((0, jsx_runtime_1.jsx)(StyledSection, __assign({ className: "wellms-component ".concat(className) }, { children: (0, jsx_runtime_1.jsx)("ul", __assign({ className: "lessons__list" }, { children: (0, jsx_runtime_1.jsx)(RecursiveLessons_1.RecursiveLessons, { lessons: lessons }) })) })));
};
var CourseAgenda = function (_a) {
    var className = _a.className, contextProps = __rest(_a, ["className"]);
    return ((0, jsx_runtime_1.jsx)(context_1.CourseAgendaContextProvider, __assign({}, contextProps, { children: (0, jsx_runtime_1.jsx)(CourseAgendaContent, { className: className }) })));
};
exports.CourseAgenda = CourseAgenda;
var NewComponent = (0, styled_components_1.default)(exports.CourseAgenda)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
exports.default = (0, styled_components_1.withTheme)(NewComponent);
var templateObject_1, templateObject_2;
